import { pushDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
import { ProductAccessoriesModel, getProductAccessories } from "@NA/Services/ProductAccessoriesService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { GetProductAccessoriesApiParameter } from "@insite/client-framework/Types/ApiModels";


type HandlerType = CustomApiHandler<GetProductAccessoriesApiParameter, ProductAccessoriesModel>;

export const DispatchLoadProductAccessories: HandlerType = (props: any) => {
    props.dispatch({
        type: "Cart/DispatchLoadProductAccessories",
        result: props.parameter,
    });
};

export const LoadProductAccessories: HandlerType = async (props: any) => {
    props.apiResult  = await getProductAccessories(props.parameter) ;
};


export const DispatchCompleteLoadProductAccessories: HandlerType = props => {
    props.dispatch({
        type: "Cart/DispatchCompleteLoadProductAccessories",
        productAccessories: props.apiResult
    });
};

export const SendTrackingCustom: HandlerType = (props: any) => {
    const {productAccessories} = props.apiResult.result; 
    const products: any[]=[];   
    if(productAccessories && productAccessories.length > 0){
        productAccessories.forEach((accessory: any) => {
            products.push(accessory.productDto);                        
        });        
        pushDataToDataLayer(products, "Accessories: Mini-Cart", props.getState().context.session);
    }        
};

export const chain = [DispatchLoadProductAccessories, LoadProductAccessories, DispatchCompleteLoadProductAccessories, SendTrackingCustom];

const loadProductAccessories = createHandlerChainRunner(chain, "loadProductAccessories");
export default loadProductAccessories;
